import { render, staticRenderFns } from "./AnimatedFaceDetection.vue?vue&type=template&id=189c62d3&scoped=true"
import script from "./AnimatedFaceDetection.vue?vue&type=script&lang=js"
export * from "./AnimatedFaceDetection.vue?vue&type=script&lang=js"
import style0 from "./AnimatedFaceDetection.vue?vue&type=style&index=0&id=189c62d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189c62d3",
  null
  
)

export default component.exports